import "./style.scss";

import React, { useEffect, useState } from "react";
import { Typography, Box, Button, CircularProgress, Skeleton } from "@mui/material";

import TopBar from "../../../components/TopBar";

import BottomBar from "../../../components/BottomBar";
import EmailHarvesting from "../../../components/EmailHarvesting";

import ProductDownload from "../../../components/ProductDownload";
import { getProduct } from "../../../util/api/productApi";
import { useDispatch, useSelector } from "react-redux";
import { setError } from "../../../actions/notificationActions";
import { AmplifierBanner, CabinetBanner, StandAloneBanner, MainBanner } from "../../../components/Products/Distant";

import AccountDialog from "../../../components/AccountDialog";
import BuyButton from "../../../components/BuyButton";

import { Helmet } from 'react-helmet';
import OverviewBanner from "../../../components/Products/Distant/Overview";
import YoutubeBanner from "../../../components/Products/Distant/YoutubeBanner";
import { PriceContent } from "../../../components/PriceComponents";
import PrePredals from "../../../components/Products/Distant/PrePedals";
import EQBanner from "../../../components/Products/Distant/EQBanner";
import PostFX from "../../../components/Products/Distant/PostFx";
import ParametricEQ from "../../../components/Products/Distant/ParametricEQ";
import PluginUtilities from "../../../components/Products/Distant/Utilities";

import originOfMadness from "../../../static/images/distant_amp/origin_of_madness.jpeg"
import asiaAustralia from "../../../static/images/distant_amp/asia_australia.jpeg"
import usaTour2025 from "../../../static/images/distant_amp/usa2025tour.jpeg"
import { DISTANT_HERO } from "../../../components/ProductHeroes";
import PromotionPopup from "../../../components/PromotionPopup";

import ReactPixel from 'react-facebook-pixel';
import { useSearchParams } from "react-router-dom";

const PRODUCT_ID = "distant-amplifier-suite"

const ExtraContentRightTopBar = ({ trigger, onTrial, priceContent, product }) => {
  return <Box
    className={trigger ? "reveal active" : "reveal"}
    sx={{
      p: 2,
      display: "flex",
      flexDirection: "row",
      columnGap: 2,
      color: "#fff",
      alignItems: "center"
    }}>
    {priceContent}
    <Button
      variant="outlined"
      size="small"
      onClick={onTrial}
    >
      Free Trial
    </Button>
    <BuyButton size="small" product={product} sx={{ width: "100px" }} />
  </Box>
}

const ExtraContentMobile = ({ product, priceContent }) => {
  return <Box sx={{
    p: 2,
    display: "flex",
    flexDirection: "row",
    columnGap: 2,
    color: "#fff",
    alignItems: "center"
  }}>
    {priceContent}
    <BuyButton size="small" product={product} sx={{ width: "90px" }} />
  </Box>
}

const PromoValues = {
  "MADNESS20": <><b>20% Discount</b></>,
  "USA20": <><b>20% Discount</b></>,
  "MERCH20DISCOUNT": <><b>20% Discount</b></>,
  "CODEDISTANT30TOUR": <>exclusive liveshow <b>30% Discount</b></>,
  "CODE50DISTANTASIA": <>exclusive liveshow <b>50% Discount</b></>
}

const Tourname = {
  "MADNESS20": "The Origin of Madness Tour",
  "USA20": "The Evisceratour",
  "CODEDISTANT30TOUR": "The Asia & Australia 2025 Tour",
  "CODE50DISTANTASIA": "The Asia & Australia 2025 Tour"
}

const Images = {
  "MADNESS20": originOfMadness,
  "USA20": usaTour2025,
  "CODEDISTANT30TOUR": asiaAustralia,
  "CODE50DISTANTASIA": asiaAustralia
}


const ReclameBanner = ({ code }) => {
  return (
    <Box sx={{
      bottom: 0,
      width: "100%",
      position: 'fixed',
      alignItems: "center",
      textAlign: "center",
      padding: 2,
      background: "black",
      zIndex: 10,
    }}>
      <Typography variant="h5" sx={{ fontSize: { xs: 16, md: 28 } }}>{Tourname[code?.toUpperCase()] && <><i>{Tourname[code?.toUpperCase()]}</i> is here! </>}{PromoValues[code?.toUpperCase()] ? <>Claim your {PromoValues[code?.toUpperCase()]} now at checkout!</> : "Enter your promotion code at checkout to check availability."}</Typography>
    </Box>
  )
}

const DistantAmplifierSuitePage = ({ useHelmet = true }) => {

  const [searchParams, setSearchParams] = useSearchParams();


  const [downloadOpen, setDownloadOpen] = useState(false);
  const [product, setProduct] = useState(undefined)
  const [loading, setLoading] = useState(true)
  const [price, setPrice] = useState(undefined)
  const [trigger, setTrigger] = useState(false);
  const [accountDialogOpen, setAccountDialogOpen] = useState(false);
  const [promoOpen, setPromoOpen] = useState(false)
  const [promoCode, setPromoCode] = useState(null)
  const [showPromoBanner, setShowPromoBanner] = useState(false);

  window.onscroll = function () {
    var scrollLimit = 500;
    setTrigger(window.scrollY >= scrollLimit);
  };

  const dispatch = useDispatch();
  const state = useSelector((state) => state)

  const fetchProduct = () => {
    getProduct(PRODUCT_ID).then((res) => {
      setLoading(false)
      setProduct(res?.data)

    }).catch(() => {
      setLoading(false)
      dispatch(setError("Something went wrong, please contact support."))
    })
  }

  useEffect(() => {
    fetchProduct()
    // eslint-disable-next-line
  }, [state?.token])

  useEffect(() => {
    const promocode = searchParams.get("promo");
    setPromoCode(promocode);
    // eslint-disable-next-line
  }, [searchParams])

  useEffect(() => {
    setShowPromoBanner(false);
    const timer = setTimeout(() => { setPromoOpen(Boolean(promoCode)) }, 666);
    return () => clearTimeout(timer);

  }, [promoCode])

  useEffect(() => {
    if (product) {
      setPrice(`€${(product?.default_price?.unit_amount / 100).toFixed(2)}`)
    }
  }, [product])

  const handleTrial = () => {
    setDownloadOpen(true)
  }




  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
      {useHelmet && <Helmet>
        <title>WaveMind Audio | ToneSuite Distant</title>
        <link rel="canonical" href="https://wavemind.net/product/distant-amplifier-suite" />
      </Helmet>}
      <TopBar
        hideTrigger={trigger}
        rightExtraAction={<ExtraContentRightTopBar trigger={trigger} product={product} onTrial={handleTrial} priceContent={<PriceContent name="ToneSuite - Distant" product={product} />} />}
        extraContentMobile={trigger ? <ExtraContentMobile product={product} priceContent={<PriceContent name="ToneSuite - Distant" product={product} />} /> : undefined} />

      <PromotionPopup image={Images[promoCode?.toUpperCase()]} campaign={Tourname[promoCode?.toUpperCase()]} discount={PromoValues[promoCode?.toUpperCase()]} heroImage={DISTANT_HERO.src} productName="ToneSuite - Distant" code={promoCode} open={promoOpen} product={product} onClose={() => { setPromoOpen(false); setShowPromoBanner(true) }} />
      <ProductDownload requireEmail open={downloadOpen} onClose={() => setDownloadOpen(false)} productID={PRODUCT_ID} />
      <AccountDialog open={accountDialogOpen} onClose={() => { setAccountDialogOpen(false) }} />

      <MainBanner price={price} product={product} onTrial={handleTrial} />
      {showPromoBanner && <ReclameBanner code={promoCode} />}
      <OverviewBanner />
      <PrePredals />
      <AmplifierBanner />
      <CabinetBanner />
      <EQBanner />
      <PostFX />
      <ParametricEQ />
      <PluginUtilities />
      <YoutubeBanner />
      <StandAloneBanner />
      <EmailHarvesting />
      <BottomBar />
    </div>
  );
};

export default DistantAmplifierSuitePage;
